/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/prop-types */
/* eslint-disable no-param-reassign */
import React from 'react';
import { connect } from 'react-redux';
import _get from 'lodash.get';
import PropTypes from 'prop-types';
import throttle from 'lodash.throttle';
import smoothScroll from 'smoothscroll';

import WithCommentLoader from 'modules/WithComments/WithCommentLoader';
// import IframeUSElection from 'components_v2/common/IframeUSElection';
import { getMilliSecondsTimestamp } from 'utils/dateUtils';
import { setPageConfigAndSendIBeatCall } from 'utils/iBeatConfig';
import AdCaller from 'helpers/ads/adCaller';
import { gaWrapper } from 'helpers/analytics';
import Optawidget from 'components_v2/common/Optawidget';
import IframeComponent from 'components_v2/common/IframeComponent';
import LoadableComponentLoader from 'components_v2/common/LoadableComponentLoader/LoadableComponentLoader';
import { openSidebar } from 'reduxUtils/modules/comments';
import { toggleLoginBox } from 'components/Login/redux';
import SocialSharingMobile from 'routes/articleshow_v2/components/mobile/SocialSharingMobile';
// import TimesClubWidgetLoader from 'components_v2/common/TimesClubWidget/TimesClubWidgetLoader';
// import WithPopup from 'modules/WithPopup';
// import LiveblogExitPollWidget from 'components_v2/elections/LiveblogExitPollWidget/LiveblogExitPollWidget';
// import LiveblogStickyElection from 'components_v2/common/LiveblogStickyElection/LiveblogStickyElectionLoader';
import MatchCornerWidget from 'components_v2/common/MatchCornerWidget';
// import FloatingSharing from 'routes/articleshow_v2/components/mobile/FloatingSharing';
import { loadInterstitialMobileAttachEvents } from 'helpers/interstitial/interstitialMobile';
// import WithElectionWidget from 'modules/WithElectionWidget';
// import PrimePaymentFlowCaller from 'components/PrimePaymentFlow/PrimePaymentFlowCaller';
import { inViewForReact, fireCustomDimension } from 'utils/common';
import WithCricketScorecardLoadableV2 from 'modules/WithCricketScorecardV2/WithCricketScorecardV2';
// import DataListicle from 'routes/jpod_DataListicles/layouts/mobile/Jpod_DataListicles';
// import EmbedDataListicleComponent from 'routes/liveblog_v2/components/common/EmbedComponent';
import TrendingMarquee from 'components_v2/mobile/TrendingMarquee/TrendingMarquee';
import Link from 'components/Link';
import { setGrxParams } from 'utils/setGrxData';
import fetchItemByMsid from '../../utils/fetchItemByMsid';
import LiveblogHeader from '../../components/common/LiveblogHeader';
import Timeline from '../../components/common/Timeline';
import OptaWidgetInLine from '../../components/common/OptaWidgetInLine';
import LeadImageVideo from '../../components/common/LeadImageVideo';
import Highlights from '../../components/mobile/Highlights';
import LiveblogScoreCard from '../../components/desktop/LiveblogScoreCard';
//import StickyOpenInApp from '../../components/common/StickyOpenInApp/StickyOpenInApp';
import MoreFromToi from '../../../articleshow_v2/components/common/MoreFromToi/MoreFromToi';
import SocialInView from '../../components/mobile/SocialInView';
import {
  widgetInsertInTimeLine,
  // addAffilateWidgetinWidgets,
  addRenewalNudgeInWidgets,
} from '../../utils/WidgetInsertInTimesline';
import Pagination from '../../components/common/Pagination';
import UpdateTimelineButton from '../../components/common/UpdateTimelineButton';
import ArticleshowCards from '../../components/common/ArticleshowCards/ArticleshowCardsLoader';
import TopStoriesWrapper from '../../components/mobile/TopStoriesWrapper';
import {
  loadTimelineDataPagination,
  loadLiveblogDataCount,
  loadTimelineData,
  loadCompleteTimelineData,
} from '../../redux';
import { LIVE_SCORE_CARD_API, TOI_LIVE_DOMAIN } from '../../../../constants';
import elementEdgesVisible from '../../utils/ElementEdgesVisible';
import s from './Liveblog_v2.scss';
import cricketWidgetsList from '../../utils/TabConstants';
import NoticeBoard from '../../../../components_v2/common/NoticeBoard/NoticeBoard';
import InViewObserver from '../../../../components/InViewObserver';
import analyticsWrapper from '../../../../helpers/analytics/analyticsWrapper';
import ErrorBoundary from '../../../../components/ErrorBoundary';
import BoardForm from '../../../../components_v2/desktop/BiharBoardResult/BoardForm';
import LinksList from '../../../../components_v2/mobile/LinksList/LinksList';
// import ElectionWidgetMainWrapper from '../../../../components/ElectionV2/ElectionWidgetMainWrapper/ElectionWidgetMainWrapper';

// const TimesClubWidgetLoaderWithPopup = WithPopup(TimesClubWidgetLoader);
const ALL_SNIPPETS = 'all_snippet';
const KEY_EVENTS = 'key_events';
const NO_RECORDS_TEXT = 'No records available under this tab';

class Liveblog extends React.Component {
  constructor(props) {
    super(props);
    this.isNonSportsLiveblog = this.checkNonSportsLiveblog();
    this.showDataListicleTabs =
      this.isNonSportsLiveblog &&
      this.props.dataListicleTabs &&
      this.props.dataListicleTabs.length > 0;
    this.showlbSnippetFilterTabs =
      (this.props.lbSnippetFilterTabs &&
        this.props.lbSnippetFilterTabs.length > 0) ||
      (props.timelineData &&
        props.timelineData.highlights &&
        props.timelineData.highlights.length > 0);
    this.combinedDataListicleTabs =
      this.showDataListicleTabs || this.showlbSnippetFilterTabs
        ? Liveblog.getInitialListicleTabList(
            props.dataListicleTabs,
            this.isNonSportsLiveblog,
          )
        : [];
    this.combinedSnippetTabs = this.showlbSnippetFilterTabs
      ? this.getInitialTabListForSnippet(props.lbSnippetFilterTabs)
      : [];
    this.state = {
      sharedWidgetData: null,
      stickyShare: '',
      ministickywidgetcls: '',
      optastickycls: '',
      refreshstickycls: '',
      showSocialMsid: '',
      cricketActiveTabObject:
        (this.showDataListicleTabs || this.showlbSnippetFilterTabs) &&
        this.combinedDataListicleTabs.length > 0
          ? this.combinedDataListicleTabs[0]
          : {
              name: 'commentary',
            },
      activeSnippetTabObject:
        this.showlbSnippetFilterTabs && this.combinedSnippetTabs.length > 0
          ? this.combinedSnippetTabs[0]
          : {},
      // activeminiwidgettab: null,
      commentsSidebar: null,
      pageUrl: `${TOI_LIVE_DOMAIN}${props.liveblog.params.fullPath}?smsid=${
        props.timelineData.msid
      }`,
      utmshare: '&source=share&medium=####&campaign=liveblog_new_web',
      // floatingUtmShare:
      //   '%26utm_source=whatsapp%26utm_medium=social%26utm_campaign=TOILiveblogicon',
      allSnippetContents: [],
      snippetSponsorMapping: {},
      nonStickyTabsLst: JSON.parse(
        JSON.stringify(
          (this.showDataListicleTabs || this.showlbSnippetFilterTabs) &&
          this.combinedDataListicleTabs.length > 0
            ? this.combinedDataListicleTabs
            : cricketWidgetsList,
        ),
      ),
      nonStickySnippetTabsList:
        this.showlbSnippetFilterTabs && this.combinedSnippetTabs.length > 0
          ? JSON.parse(JSON.stringify(this.combinedSnippetTabs))
          : [],
      showPriorityTabsNudge: true,
      // readNextApiFailEventCaptured: {},
    };
    this.scrollGAElements = [];
    this.handledScrollGAElements = {};
    this.timelineRef = React.createRef();
    this.OptaWidgetInLineRef = React.createRef();
    this.optaListicleTabsRef = React.createRef();
    this.gaCategory = 'liveblog_new_mweb';
    this.cricketLiveBlog =
      props.timelineData &&
      props.timelineData.liveBlogType &&
      props.timelineData.liveBlogType.toLowerCase() === 'cricket';
    const { metaInfo = {} } = this.props.liveblog;
    this.isSportsCricketLB = !!(metaInfo && metaInfo.isCricketLiveblog);
  }

  /**
   * This is to combine Snippet Filter Tabs with keyEvents tab if exists,
   * Structure : All | Key Events | <Tabs Filter...>
   * @param {Object} lbFilterTabs | Liveblog associated Snippet Filters from CARDs API
   */
  getInitialTabListForSnippet(lbFilterTabs) {
    try {
      const { lbSnippetFilterTabsMeta } = this.props;
      const TabForAllContents = {
        code: ALL_SNIPPETS,
        decode: 'All',
        description: '',
        sponsor_url:
          (lbSnippetFilterTabsMeta && lbSnippetFilterTabsMeta.sponsor_url) ||
          '',
        sponsor_logo_url:
          (lbSnippetFilterTabsMeta &&
            lbSnippetFilterTabsMeta.sponsor_logo_url) ||
          '',
        sponsor_campaign_code: '',
        genre: 'live-blog',
      };
      return [TabForAllContents, ...lbFilterTabs];
    } catch (error) {
      return [];
    }
  }

  /**
   * This is to combine Listicle Tabs with All Updates tab if exists,
   * Structure : Updates | <Listicle Tabs...>
   * @param {Object} lbFilterTabs | Liveblog associated Listicle Tabs from CARDs API
   */
  static getInitialListicleTabList(lbFilterTabs, isNonSportsLiveblog) {
    try {
      if (!isNonSportsLiveblog) {
        return cricketWidgetsList;
      }
      const TabForAllUpdates = {
        displayName: 'News Updates',
        name: 'lb_updates',
        type: 'commentary',
        gaLabel: 'tab_click_Updates',
      };
      if (lbFilterTabs && lbFilterTabs instanceof Array) {
        return [TabForAllUpdates, ...lbFilterTabs];
      }
      return [TabForAllUpdates];
    } catch (error) {
      return [];
    }
  }

  checkNonSportsLiveblog() {
    const { metaInfo = {} } = this.props.liveblog;
    return !!(metaInfo && metaInfo.isNonSportsLiveblog);
  }

  componentDidMount() {
    // const { metaInfo = {} } = this.props.liveblog;
    // const { msid } = this.props.timelineData;
    // const { loadReadNextBundles, isPrime } = this.props;
    // const templateVal = 'liveblog';
    // const codeVal = metaInfo?.LiveBlogName
    //   ? `/signals_liveblog${metaInfo?.LiveBlogName}`
    //   : '/signals_liveblog';
    // if (isPrime) {
    //   loadReadNextBundles({
    //     code: codeVal,
    //     user_prime_status: isPrime ? 'prime' : 'non-prime',
    //     client: 'browser',
    //     mode: 'data',
    //     template: templateVal,
    //     article_prime_status: 'non-prime',
    //     articleId: msid,
    //     limit: 25,
    //   });
    // }

    // const { liveBlogType } = this.props.timelineData;
    this.setDfpTargetingKeyword();
    // const { isEtimes } = this.props;
    if (
      typeof window !== 'undefined' &&
      window.location &&
      window.location.href &&
      window.location.href.includes('/sports/')
    ) {
      this.gaCategory = 'SportsLiveblog_New';
    } else this.gaCategory = 'liveblog_new_mweb';
    // this.cricketLiveBlog =
    //   liveBlogType && liveBlogType.toLowerCase() === 'cricket';
    setGrxParams(this.props.liveblog, {
      contentType: 'liveblog',
    });
    //const url = window.location && window.location.href;
    // this.gaCategory =
    //   (this.cricketLiveBlog && !isEtimes && 'SportsLiveblog_New') ||
    //   'liveblog_new_mweb';
    if (
      typeof window !== 'undefined' &&
      window.sessionStorage &&
      sessionStorage.getItem('planName')
    ) {
      fireCustomDimension(sessionStorage.getItem('planName'), 'dimension33');
    }
    // gaWrapper('send', 'event', this.gaCategory, 'page_load', url, {
    //   nonInteraction: 1,
    // });
    this.fetchSharedItemData();
    this.setScrollGAElements();
    this.throttledScroll = throttle(this.handleOnScroll, 100);
    window.addEventListener('scroll', this.throttledScroll);

    document.addEventListener('click', this.clickHandler);
    setPageConfigAndSendIBeatCall(this.props.timelineData, true);
    loadInterstitialMobileAttachEvents();
    // create snippet-sponsorBy mapping
    this.createSnippetSponsorMapping();
    // call to get all Liveblog snippet contents
    this.setState({ allSnippetContents: this.props.allSnippetContents });
  }

  createSnippetSponsorMapping() {
    const currentSnippetTabList = this.props.lbSnippetFilterTabs;
    if (
      currentSnippetTabList instanceof Array &&
      currentSnippetTabList.length > 0
    ) {
      const mapping = Array.prototype.reduce.call(
        currentSnippetTabList,
        (map, item) => {
          if (item && item.code) {
            map[item.code.toLowerCase()] = item;
          }
          return map;
        },
        {},
      );
      this.setState({ snippetSponsorMapping: mapping });
    }
  }
  setDfpTargetingKeyword() {
    const targetingKeyword = _get(this.props.liveblog, `newsKws`);
    if (typeof targetingKeyword !== 'string') {
      return;
    }
    window.googletag = window.googletag || {};
    window.googletag.cmd = window.googletag.cmd || [];
    window.googletag.cmd.push(() => {
      window.googletag.pubads().setTargeting('keyword', targetingKeyword);
    });
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.throttledScroll);

    document.removeEventListener('click', this.clickHandler);
  }
  // componentDidUpdate() {
  //   this.setScrollGAElements();
  // }
  clickHandler = event => {
    const clickElem = event.target;
    const allSocial = [...document.querySelectorAll('[data-socialClick]')];
    let msid = '';
    allSocial.forEach(elem => {
      if (clickElem === elem) {
        msid = elem.getAttribute('data-socialClick');
      }
    });
    this.setState({ showSocialMsid: msid });
  };
  setScrollGAElements = () => {
    try {
      this.scrollGAElements = [
        ...document.querySelectorAll('[data-scrollga]:not([data-scrollga=""])'),
      ];
    } catch (e) {
      // console.log(e);
    }
  };
  handleOnScroll = () => {
    const prevTop = 0;
    let currentTop = 0;
    const doc = document.documentElement;
    currentTop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    if (currentTop > prevTop) {
      for (let i = 0; i < this.scrollGAElements.length; i += 1) {
        if (
          this.scrollGAElements[i] &&
          ((this.cricketLiveBlog &&
            inViewForReact(this.scrollGAElements[i], 0, true)) ||
            elementEdgesVisible(this.scrollGAElements[i], true))
        ) {
          let gaData =
            this.scrollGAElements[i].getAttribute('data-scrollga') || '';
          gaData = gaData.split('#');
          const action = gaData[0] || '';
          const label =
            gaData[1] ||
            (typeof window !== 'undefined' && window.location.href);
          // Remove GAs as reqd in TOIPR-70372
          if (
            (this.gaCategory === 'liveblog_new_mweb' ||
              this.gaCategory === 'SportsLiveblog_New') &&
            action === 'scroll'
          ) {
            return;
          }
          if (
            (this.gaCategory === 'liveblog_new_mweb' ||
              this.gaCategory === 'SportsLiveblog_New') &&
            action === 'ad_view_'
          ) {
            return;
          }
          gaWrapper('send', 'event', this.gaCategory, action, label, {
            nonInteraction: 1,
          });
          this.scrollGAElements[i].removeAttribute('data-scrollga');
          this.scrollGAElements.splice(i, 1);
        }
      }
    }
  };

  fetchSharedItemData() {
    const { msid } = this.props.timelineData;
    const { sharedMsid } = this.props;
    if (!sharedMsid) {
      return;
    }
    fetchItemByMsid(msid, sharedMsid)
      .then(data => {
        if (!(data && data.data)) {
          return;
        }
        this.setState({
          sharedWidgetData: data.data,
        });
      })
      .catch(e => console.log('err fetchItemByMsid', e));
  }
  getCommentsData = msid => {
    let commentCount = 0;
    // eslint-disable-next-line react/prop-types
    if (this.props.comments && this.props.comments[`commentsData-${msid}`]) {
      const commentsData = this.props.comments[`commentsData-${msid}`];
      commentCount = commentsData[0] ? commentsData[0].totalcount : 0;
    }

    return commentCount;
  };

  stickyShareIcons = (val, upScroll, withminiwidget) => {
    const { isEtimes, timelineData } = this.props;
    const cricketLiveBlog =
      timelineData &&
      timelineData.liveBlogType &&
      timelineData.liveBlogType.toLowerCase() === 'cricket';
    let cls = '';
    let widgetcls = '';
    let optatabcls = '';
    let refreshCls = '';
    if (val) {
      cls = upScroll
        ? ((withminiwidget || this.showDataListicleTabs) &&
            s.stickyShareHide) ||
          s.stickyShareUp
        : (withminiwidget && s.stickyShareHide) || s.stickyShare;
      widgetcls = upScroll ? s.withstickywidgetUp : s.withstickywidget;
      optatabcls = upScroll
        ? ''
        : (withminiwidget && s.optaStickyTab) || s.listicleStickyTab;
    }

    if (!isEtimes && cricketLiveBlog && val && widgetcls !== '' && !upScroll) {
      refreshCls = 'newupdateC1';
    } else if (
      !isEtimes &&
      cricketLiveBlog &&
      val &&
      widgetcls !== '' &&
      upScroll
    ) {
      refreshCls = 'newupdateC2';
    } else if (
      !isEtimes &&
      !cricketLiveBlog &&
      val &&
      widgetcls !== '' &&
      !upScroll
    ) {
      refreshCls = 'newupdateC5';
    } else if (
      !isEtimes &&
      !cricketLiveBlog &&
      val &&
      widgetcls !== '' &&
      upScroll
    ) {
      refreshCls = 'newupdateC6';
    } else if (isEtimes && val && widgetcls !== '' && !upScroll) {
      refreshCls = 'newupdateC3';
    } else if (isEtimes && val && widgetcls !== '' && upScroll) {
      refreshCls = 'newupdateC4';
    }

    this.setState({
      stickyShare: cls,
      ministickywidgetcls: widgetcls,
      optastickycls: optatabcls,
      refreshstickycls: refreshCls,
    });
  };
  openSideBar = (msid, id) => {
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    this.props.openSidebar(msid, id);
  };

  getLetestTime = (upd, lastupd) => {
    const newupd = Number(getMilliSecondsTimestamp(upd));
    const newlastupd = Number(getMilliSecondsTimestamp(lastupd));
    if (newlastupd > newupd) return newlastupd;
    return newupd;
  };

  hidePriorityTabsNudge = () => {
    this.setState({ showPriorityTabsNudge: false });
  };

  loadNewOptaWidgets = item => {
    const conId = `container-${item.name}`;
    const mainContainer = document.getElementById(conId);
    if (
      typeof mainContainer === 'object' &&
      mainContainer !== null &&
      typeof Opta !== 'undefined'
    ) {
      const optaWidgetTags = mainContainer.getElementsByTagName('opta-widget');
      let unloadedWidget = false;
      if (optaWidgetTags.length > 0) {
        for (let i = 0; i < optaWidgetTags.length; i += 1) {
          if (optaWidgetTags[i].getAttribute('load') === 'false') {
            unloadedWidget = true;
            optaWidgetTags[i].removeAttribute('load');
          }
        }
        if (unloadedWidget === true) {
          // eslint-disable-next-line no-undef
          Opta.start();
        }
      }
    }
  };
  getFullUrl = () => {
    const { params } = this.props.liveblog;
    const { msid } = this.props.timelineData;
    return `${TOI_LIVE_DOMAIN}${params.fullPath}?smsid=${msid}`;
  };

  getTitle = () => {
    const { title } = this.props;
    return title;
  };
  resumeFocusedOptaWidgets = () => {
    if (typeof Opta !== 'undefined') {
      const widgetContainers = document.getElementsByClassName('Opta');
      if (widgetContainers.length > 0) {
        for (let i = 0; i < widgetContainers.length; i += 1) {
          if (
            typeof widgetContainers[i] !== 'undefined' &&
            widgetContainers[i] !== null
          ) {
            const widgetId = widgetContainers[i].getAttribute('id');
            // eslint-disable-next-line no-undef
            const Widget = Opta.widgets[widgetId];
            Widget.resume(Widget.live, Widget.first_time);
          }
        }
      }
    }
  };

  pauseHiddenOptaWidgets = () => {
    if (typeof Opta !== 'undefined') {
      const widgetContainers = document.getElementsByClassName('Opta');
      if (widgetContainers.length > 0) {
        for (let i = 0; i < widgetContainers.length; i += 1) {
          const widgetId = widgetContainers[i].getAttribute('id');
          // eslint-disable-next-line no-undef
          const Widget = Opta.widgets[widgetId];
          Widget.pause();
        }
      }
    }
  };

  tabClickHandler = (event, item) => {
    try {
      this.changeCricketTabs(item, event);
      if (this.state.optastickycls) {
        const elem = document.querySelector('#optatabsanchor');
        if (elem) {
          const elemTop = elem.getBoundingClientRect();
          const scrollTop =
            window.pageYOffset || document.documentElement.scrollTop;
          const top = elemTop.top + scrollTop;
          smoothScroll(top - 50, 700);
        }
      }
    } catch (error) {
      console.info('error', error);
    }
  };

  sendPageviewOnTabChanges = item => {
    if (
      this.showDataListicleTabs &&
      item.name !== this.state.cricketActiveTabObject.name
    ) {
      if (item.type === 'dataListicle') {
        const newUrl = `${TOI_LIVE_DOMAIN}${
          item.url.startsWith('/') ? item.url : `/${item.url}`
        }`;
        const utmShare = `utm_source=liveblog&utm_medium=newscards&utm_term=${
          item.url
        }&utm_content=factsheet`;
        let replaceUrl = `${
          item.url.startsWith('/') ? item.url : `/${item.url}`
        }`;
        if (replaceUrl.includes('?')) {
          replaceUrl = `${replaceUrl}&${utmShare}`;
        } else {
          replaceUrl = `${replaceUrl}?${utmShare}`;
        }
        this.setState({
          pageUrl: newUrl,
          utmshare: utmShare,
          // floatingUtmShare:
          //   '?utm_source=whatsapp%26utm_medium=social%26utm_campaign=TOILiveblogicon',
        });
        window.history.replaceState({}, undefined, replaceUrl);
        gaWrapper('send', {
          hitType: 'pageview',
          page: replaceUrl,
          dimension26: 'liveblog_factsheet',
        });
      } else if (item.type === 'commentary' && this.showDataListicleTabs) {
        const newUrl = `${TOI_LIVE_DOMAIN}${
          this.props.liveblog.params.fullPath
        }?smsid=${this.props.timelineData.msid}`;
        const replaceUrl = this.props.liveblog.params.fullPath;
        this.setState({
          pageUrl: newUrl,
          utmshare: '&source=share&medium=####&campaign=liveblog_new_web',
          // floatingUtmShare:
          //   '%26utm_source=whatsapp%26utm_medium=social%26utm_campaign=TOILiveblogicon',
        });
        window.history.replaceState({}, undefined, replaceUrl);
        gaWrapper('send', {
          hitType: 'pageview',
          page: replaceUrl,
          dimension26: 'liveblog_exp_new',
        });
      }
    }
  };

  changeCricketTabs = (item, event) => {
    if (event && event.target && event.target instanceof HTMLElement) {
      event.target.scrollIntoViewIfNeeded(false);
    }
    if (this.showDataListicleTabs) {
      this.sendPageviewOnTabChanges(item);
    }

    this.setState({ cricketActiveTabObject: item }, () => {
      gaWrapper('send', 'event', this.gaCategory, 'click', item.gaLabel);
      if (item.type === 'optaWidget') {
        this.loadNewOptaWidgets(item);
        this.pauseHiddenOptaWidgets();
        this.resumeFocusedOptaWidgets();
      } else if (
        this.OptaWidgetInLineRef &&
        typeof this.OptaWidgetInLineRef.setDefaultActiveTab === 'function' &&
        item.type === 'commentary'
      ) {
        this.OptaWidgetInLineRef.setDefaultActiveTab();
      }
    });
  };

  onSnippetTabsClick = (event, item) => {
    if (event && event.target && event.target instanceof HTMLElement) {
      event.target.scrollIntoViewIfNeeded(false);
    }
    const { code } = item;
    const { timelineData: { highlights = [] } } = this.props;
    if (
      code === KEY_EVENTS &&
      highlights instanceof Array &&
      highlights.length > 0
    ) {
      this.setState({ allSnippetContents: highlights });
    } else if (code !== KEY_EVENTS && code !== ALL_SNIPPETS) {
      const filteredSnippetContents = this.props.allSnippetContents.filter(
        snippet =>
          snippet.metainfo &&
          snippet.metainfo.LiveBlogFilter &&
          snippet.metainfo.LiveBlogFilter.toLowerCase() === code.toLowerCase(),
      );
      if (filteredSnippetContents.length > 0) {
        this.setState({ allSnippetContents: filteredSnippetContents });
      } else {
        this.setState({ allSnippetContents: [] });
      }
    }
    this.setState({
      activeSnippetTabObject: item,
    });
  };

  // changeminiwidgettab = activeTab => {
  //   this.setState({ activeminiwidgettab: activeTab });
  // };

  loadCommentsSidebar = sidebarJsx => {
    if (React.isValidElement(sidebarJsx)) {
      this.setState({ commentsSidebar: sidebarJsx });
    }
  };
  // setReadNextApiFailEventTrigger = articleId => {
  //   const { readNextApiFailEventCaptured } = this.state;
  //   this.setState({
  //     readNextApiFailEventCaptured: {
  //       ...readNextApiFailEventCaptured,
  //       [articleId]: true,
  //     },
  //   });
  // };
  getMrecAD = () => {
    if (!this.props.isPrime) {
      return (
        <AdCaller
          skipReRender
          adWapperClass="ad_300by250"
          data={{
            name: 'mrec',
          }}
          immediateLoad
          deviceType="mobile"
        />
      );
    }
    return null;
  };

  getResultAdCode = () =>
    // TODO: JARVIS | Will removed once move on jarvis
    this.props.isPrime
      ? null
      : {
          adCode: '/7176/TOI_MWeb/TOI_MWeb_Result/TOI_MWeb_RSLTDAY',
          size: [120, 30],
        };
  render() {
    const {
      title1: title,
      information1: information,
      mobilesynopsis,
      lastupd,
      msid,
      highlights,
      liveBlogType,
    } = this.props.timelineData;
    const {
      quickLinks = [],
      widgets = [],
      params,
      count,
      contents,
      seo = {},
      metaInfo = {},
      newCount,
      ads,
      inlineAds,
      images = [],
      nextLinks = [],
      upd,
      slikeId,
      affKeyword,
      navsubsecs,
      des,
      cardsInsertsLite,
    } = this.props.liveblog;
    const {
      isAppView,
      electionFlag,
      isEtimes,
      location,
      isSports,
      isWorld,
    } = this.props;
    const articleId = _get(this.props.timelineData, 'msid');

    const tabContentList = this.showDataListicleTabs
      ? this.props.dataListicleTabs
      : cricketWidgetsList;

    let ASCardsData = null;
    let topStoriesData = null;
    nextLinks.forEach(item => {
      if (item.tn === 'NewsList') {
        ASCardsData = item;
      } else if (item.tn === 'NumberedList') {
        topStoriesData = item;
      }
    });

    const { isLoggedIn } = this.props.userData;
    const showOptaWidgets =
      metaInfo &&
      metaInfo.MigrationId !== 'undefined' &&
      metaInfo.MigrationId !== '' &&
      typeof metaInfo.SupplementaryContentId !== 'undefined' &&
      metaInfo.SupplementaryContentId !== '' &&
      typeof metaInfo.DeviceId !== 'undefined' &&
      metaInfo.DeviceId !== '';

    let updatedContents = [...contents];
    // let updatedWidgets = addAffilateWidgetinWidgets([...(widgets || [])], true);
    let updatedWidgets = [...(widgets || [])];
    if (this.props.isPrime && this.props.showToiPlusNudges) {
      updatedWidgets = addRenewalNudgeInWidgets(
        [...(updatedWidgets || [])],
        true,
      );
    }
    if (contents instanceof Array && updatedWidgets instanceof Array) {
      updatedContents = widgetInsertInTimeLine(
        updatedWidgets,
        inlineAds,
        contents,
        ads,
      );
    }

    const pageUrl = `${TOI_LIVE_DOMAIN}${params.fullPath}?smsid=${msid}`;
    // const colorThemeClass = this.props.colorTheme;

    const NewExitPollData =
      updatedWidgets instanceof Array && updatedWidgets.length > 0
        ? updatedWidgets.find(wdt => wdt.tn === 'electionwdt')
        : undefined;

    const cricketLiveBlog =
      liveBlogType && liveBlogType.toLowerCase() === 'cricket';
    const showScoreCard = cricketLiveBlog && metaInfo.Matchid;
    const { cricketActiveTabObject, activeSnippetTabObject } = this.state;
    const { matchStatus } = this.props;
    let activeOptaIndex = 'match_action';
    if (
      matchStatus &&
      matchStatus.matchStatus &&
      matchStatus.matchStatus.toLowerCase() === 'match ended'
    ) {
      activeOptaIndex = 'wagonwheel';
    } else if (
      matchStatus &&
      matchStatus.currentInning &&
      matchStatus.currentInning.toLowerCase() === 'second'
    ) {
      activeOptaIndex = 'manhattan';
    }

    let matchDetailsData = {
      data: { playerthumbs: { data: {} }, playingeleven: { data: [] } },
    };
    matchDetailsData =
      this.props.sidebarData &&
      this.props.sidebarData.data &&
      this.props.sidebarData.data.length &&
      this.props.sidebarData.data.find(item => item.tn === 'matchcornerwidget');

    // renderMiniWidget renders Scorecard widget and Election new poll widget
    const renderMiniWidget = isMiniWidget => {
      let props = {};
      if (!showScoreCard && NewExitPollData) {
        props = isMiniWidget && {
          dots: false,
          arrows: false,
          barchart: false,
          deceasedinfomsg: false,
          cssObject: { statewrapper: s.stickyelectionwidget },
        };
        if (!electionFlag) {
          return null;
        }
        return (
          // To make the election widget sticky
          <></>
        );
      } else if (showScoreCard) {
        return (
          <LiveblogScoreCard
            msid={msid}
            microScoreCard
            sponsorAd=""
            isWapView
            {...props}
          />
        );
      }
      return null;
    };

    const topSearches = _get(this.props, 'commonData.topSearches');
    const description = des?.length && des.length > 200;
    return (
      <React.Fragment>
        {/* Top sticky social share starts here */}
        <div>
          {!isAppView && (
            <React.Fragment>
              <div className={`${s.hideshowsticky} ${this.state.stickyShare}`}>
                <SocialSharingMobile
                  msid={msid}
                  title={title}
                  url={this.state.pageUrl}
                  wu={this.state.pageUrl}
                  via="@timesofindia"
                  whatsAppShow
                  isWapView
                  sticky
                  isTablet={false}
                  wrapperClass="mobile-socialshare-top"
                  gaCategory={this.gaCategory}
                  gaAction="sticky_share_header"
                  commentsCount={this.getCommentsData(msid)}
                  showComment
                  openSidebar={this.openSideBar}
                  forceOpenSidebar
                  utm={this.state.utmshare}
                  disableShortUrl
                  hideSharingButtons
                  tpShow
                  hideSharingNative
                  isLiveBlog
                />
              </div>
            </React.Fragment>
          )}
        </div>

        {/* Top floating updatetimeline button starts here */}
        <UpdateTimelineButton
          getNewUpdates={p => {
            this.props.loadTimelineData(p);
            this.props.loadCompleteTimelineData(p);
          }}
          updateCount={this.props.loadLiveblogDataCount}
          params={params}
          count={count}
          newCount={newCount}
          timelineRef={this.timelineRef && this.timelineRef.current}
          isWapView
          gaCategory={this.gaCategory}
          btnClass={this.state.refreshstickycls}
        />

        {/* Floating openapp/whatsapp sharing cta starts here */}
        {/* {!isAppView &&
          !this.props.affiliatesNudgeVisible && (
            <FloatingSharing
              isWapView
              isTablet={false}
              gaCategory="WhatsappShare"
              gaAction="click"
              overideurl={this.state.pageUrl}
              getFullUrl={this.getFullUrl}
              getShortUrl={this.getFullUrl}
              getTitle={this.getTitle}
              utm={this.state.floatingUtmShare}
              encode={false}
            />
          )} */}

        {/* This placeholder is for comments sidebar, moved here to prevent CLS */}
        <div>{this.state.commentsSidebar}</div>

        {/* This placeholder is for components render via portals, this is to prevent CLS */}
        <div className="popupWrapper" />

        {/* Sticky scorecard/new election poll widget starts here */}
        {!!(showScoreCard || NewExitPollData) && (
          <div
            data-stickywidget={msid}
            className={`${s.ministickywidget} ${
              this.state.ministickywidgetcls
            }`}
          >
            {renderMiniWidget(true)}
          </div>
        )}
        <div
          className={`wrapperclearfix ${this.isNonSportsLiveblog &&
            s.nonSportsLBWrapper}`}
          data-translate-id="cw"
        >
          {/* Liveblog title header & description starts here */}
          <div className="head">
            <LiveblogHeader
              title={title}
              information={des && des !== '' ? des : information}
              lastupd={this.getLetestTime(upd, lastupd)}
              msid={msid}
              matchStatus={this.props.matchStatus}
              isNonSportsLiveblog={this.isNonSportsLiveblog}
              sponsorLead="Sponsored by"
              sponsorLogoUrl={
                this.state.activeSnippetTabObject.sponsor_logo_url
              }
              sponsorCtaUrl={this.state.activeSnippetTabObject.sponsor_url}
              liveblogName={
                this.props.lbSnippetFilterTabsMeta &&
                this.props.lbSnippetFilterTabsMeta.decode &&
                `${this.props.lbSnippetFilterTabsMeta.decode} ${
                  this.state.activeSnippetTabObject.decode &&
                  this.state.activeSnippetTabObject.code !== ALL_SNIPPETS &&
                  this.state.activeSnippetTabObject.code !== KEY_EVENTS
                    ? `| ${this.state.activeSnippetTabObject.decode}`
                    : ''
                }`
              }
              headerLeftAlign={
                this.isSportsCricketLB || this.isNonSportsLiveblog
              }
              // extraData={this.props.liveblog.extraData}
              // miniScorecard={this.props.miniScorecard}
              // loadMiniScorecardData={this.props.loadMiniScorecardData}
              // timelineData={this.props.timelineData}
              // autoRefreshRate={this.props.liveblog.autoRefreshRate}
              // seoData={{ ...this.props.liveblog.seoData }}
              // params={this.props.params}
              // imgSize={this.props.liveblog.imgSize}
              // timestampSource={this.props.liveblog.timestampSource}
              // slikeId={this.props.liveblog.slikeId}
              // colorTheme={this.props.colorTheme}
              // openOverlay={this.props.openOverlay}
              // breadCrumbData={this.props.breadCrumbData}
              // //frmApp={frmapp}
              // exitPollData={this.props.liveblog.electiondata}
              // //isElection={this.props.electionData.tn === 'resulttable'}
              // fixedHeaderStatus={this.props.fixedHeaderStatus}
            />
            {(showScoreCard || showOptaWidgets) &&
              this.state.cricketActiveTabObject &&
              this.state.cricketActiveTabObject.name !== 'commentary' && (
                <SocialInView
                  cbForSticky={this.stickyShareIcons}
                  msid={msid}
                  withminiwidget={!!(showScoreCard || NewExitPollData)}
                />
              )}
          </div>
          {(isEtimes || isSports || isWorld) &&
            (description && this.getMrecAD())}
          {/**
           * Lead Image/Video starts here,
           * Removed for sports cricket LB
           */}
          {Array.isArray(images) &&
            images.length && (
              <LeadImageVideo
                title={title}
                msid={msid}
                imageData={images[0]}
                slikeId={slikeId}
              />
            )}
          {/* This is the old exitpoll widget, TODO: check if this can be removed */}
          {/* {this.props.extraData &&
            this.props.extraData.feedURL && (
              <LiveblogExitPollWidget
                exitPollData={this.props.extraData}
                colorThemeClass={colorThemeClass}
                isElection
                feedUrl={this.props.extraData.feedURL}
                // fixedHeaderStatus={this.props.fixedHeaderStatus}
              />
            )} */}
          {/* This is the old exitpoll widget, TODO: check if this can be removed */}
          {/* {this.props.exitPollData && this.props.exitPollData.feedURL ? (
            <LiveblogExitPollWidget
              exitPollData={this.props.exitPollData}
              colorThemeClass={colorThemeClass}
              isElection={false}
              feedUrl={this.props.exitPollData.feedURL}
              // fixedHeaderStatus={this.props.fixedHeaderStatus}
            />
          ) : null} */}
          {
            // <>
            //   <IframeUSElection isMobile isliveblog />
            // </>
          }
          {!metaInfo.isCricketLiveblog && (
            <div className={s.social_keyhighlight_wrapper}>
              {!isAppView && (
                <React.Fragment>
                  <div className={`${s.MoiblestickyShare}`}>
                    <SocialSharingMobile
                      msid={msid}
                      title={title}
                      url={this.state.pageUrl}
                      wu={this.state.pageUrl}
                      via="@timesofindia"
                      //whatsAppShow
                      isWapView
                      sticky
                      isTablet={false}
                      wrapperClass="mobile-socialshare-top"
                      gaCategory={this.gaCategory}
                      gaAction={
                        this.state.stickyShare !== ''
                          ? 'sticky_share_header'
                          : 'atf_share'
                      }
                      commentsCount={this.getCommentsData(msid)}
                      // showComment={this.state.stickyShare !== ''}
                      openSidebar={this.openSideBar}
                      forceOpenSidebar
                      utm={this.state.utmshare}
                      disableShortUrl
                      hideSharingButtons
                      tpShow
                      hideSharingNative
                      isLiveBlog
                    />
                  </div>
                  {/* {!!(showScoreCard || NewExitPollData) && (
                  <div
                    data-stickywidget={msid}
                    className={`${s.ministickywidget} ${
                      this.state.ministickywidgetcls
                    }`}
                  >
                    {renderMiniWidget(true)}
                  </div>
                )} */}
                  <SocialInView
                    cbForSticky={this.stickyShareIcons}
                    msid={msid}
                    withminiwidget={!!(showScoreCard || NewExitPollData)}
                  />
                </React.Fragment>
              )}

              {!showScoreCard &&
                !isEtimes && (
                  <div className={s.iplWidgetPageWraper}>
                    <ErrorBoundary>
                      <LoadableComponentLoader
                        loadInView
                        loadableComponentName="IPLWidgetV2"
                        wrapperClass="iplcricketwidget"
                        flipAd
                        dataUrl={LIVE_SCORE_CARD_API}
                        isStickyCard
                        autoRefresh
                        isWapView
                        gaData="Scorecard_widget|click_mweb|Liveblog"
                        gaViewData={[
                          'Scorecard_widget',
                          'view_mweb',
                          'Liveblog',
                        ]}
                      />
                    </ErrorBoundary>
                  </div>
                )}

              {/* Removed key-highlights feature to incorporate factsheets */}
              {isSports &&
              highlights &&
              highlights instanceof Array &&
              !!highlights.length ? (
                <InViewObserver
                  inViewCallback={() => {
                    analyticsWrapper('ga4', {
                      event: 'user_shown',
                      type: `pinned_news`,
                      label: highlights.slice(0, 3).length,
                    });
                  }}
                >
                  <div className={`${s.nbOuterWrap} slick_UI`}>
                    <div className={s.keyTakewayWrapper}>
                      <div className={s.keyTakeway}>
                        <NoticeBoard
                          badge="https://static.toiimg.com/photo/98653352.cms"
                          boardName="Key Events"
                          dots
                          arrows
                          boardItems={highlights.slice(0, 3)}
                          isWapView
                          seoEnabled={false}
                          ga4Type="pinned_news"
                        />
                      </div>
                      <AdCaller
                        data={{ jname: 'key_event_rhs' }}
                        adWapperClass={s.keyTakewayAd}
                      />
                    </div>
                  </div>
                </InViewObserver>
              ) : null}
            </div>
          )}
          {!isEtimes &&
            !isSports &&
            !isWorld &&
            description &&
            this.getMrecAD()}
          {/* // TODO: Election Widget */}
          {/* {NewExitPollData && (
            <ErrorBoundary>
              <InViewObserver
                inViewCallback={() => {
                  analyticsWrapper('ga4', {
                    event: 'user_shown',
                    type: `exitpoll_widget`,
                  });
                }}
              >
                <div className={s.lbElectionWidgetWrap}>
                  <ElectionWidgetMainWrapper
                    isWapView
                    isPowerByAd={this.props?.isPowerByAd}
                    isPowerByAdActive={this.props?.isPowerByAdActive}
                    tabs={this.props?.electionTabs}
                    hideStarCandidate
                    hideLiveblog
                    hideHeading
                    hideSharing
                    hideTitle
                    hideInfocus
                    hideDisplayText
                    hidePowerStates
                    isInnerWidget
                    hideETheading
                    electionwdtWap
                  />
                </div>
              </InViewObserver>
            </ErrorBoundary>
          )} */}
          {this.state.showPriorityTabsNudge &&
            this.props.dataListicleTabs &&
            this.props.dataListicleTabs.length > 0 &&
            this.showDataListicleTabs &&
            !isEtimes && (
              <div className={s.autoPriorityTabs_nudge}>
                <p>
                  For what’s happening, click on news updates. For context,
                  click on other tabs.
                </p>
                <button
                  className={s.autoPriorityTabs_nudge_close}
                  onClick={this.hidePriorityTabsNudge}
                >
                  x
                </button>
              </div>
            )}
          {/**
           * This creates Tab Middle content Tab List
           */}
          {!this.cricketLiveBlog && !description && this.getMrecAD()}
          {(showScoreCard ||
            showOptaWidgets ||
            this.showDataListicleTabs ||
            this.showlbSnippetFilterTabs) && (
            <>
              <div className={s.optatabsanchor} id="optatabsanchor" />
              <div
                ref={this.optaListicleTabsRef}
                data-translate-sticky="45"
                className={`${s.tabListWrapper} ${this.state.optastickycls}`}
                //data-scrollga="tab_view"
              >
                <ul className={s.tabList}>
                  {this.state.nonStickyTabsLst.map((item, index) => {
                    if (
                      item.type === 'timescricket' &&
                      matchStatus &&
                      matchStatus.matchType !== 'T20'
                    )
                      return null;
                    if (item.type === 'optaWidget' && !showOptaWidgets)
                      return null;
                    if (item.type === 'scorecard' && !showScoreCard)
                      return null;
                    if (
                      item.type === 'dataListicle' &&
                      !item.dataurl &&
                      this.showDataListicleTabs
                    )
                      return null;
                    return (
                      <li
                        key={index}
                        onClick={event => this.tabClickHandler(event, item)}
                        className={
                          item.name ===
                          (this.state.cricketActiveTabObject &&
                            this.state.cricketActiveTabObject.name)
                            ? `${s.tabItem} ${s.active}`
                            : `${s.tabItem}`
                        }
                      >
                        {item.displayName}{' '}
                        {item &&
                          (item.name === activeOptaIndex ||
                            item.name === 'timescricketInfografcrics') && (
                            <i className={s.liveupdate} />
                          )}
                        {item &&
                          item.is_toiplus && <i className={s.toiplusicon} />}
                      </li>
                    );
                  })}
                </ul>
              </div>
            </>
          )}
          {/* Liveblog Snippets Filter Tabs */}
          {this.showlbSnippetFilterTabs &&
            !(
              this.state.nonStickySnippetTabsList.length === 1 &&
              this.state.nonStickySnippetTabsList[0].code === ALL_SNIPPETS
            ) && (
              <div
                className={`${s.snippettabs} ${
                  !(
                    cricketActiveTabObject.name === 'commentary' ||
                    cricketActiveTabObject.name === 'lb_updates'
                  )
                    ? s.hidesnippettabs
                    : ''
                }`}
              >
                <ul>
                  {this.state.nonStickySnippetTabsList.map((item, index) => (
                    <li
                      key={index}
                      className={`${s.snippettabitem} ${
                        this.state.activeSnippetTabObject.code === item.code
                          ? s.active
                          : ''
                      }`}
                    >
                      <Link
                        href="javascript: void(0)"
                        onClick={e => this.onSnippetTabsClick(e, item)}
                      >
                        {item.decode}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          {/**
           * This creates Different middle Tab containers
           */}
          {(showScoreCard || showOptaWidgets || this.showDataListicleTabs) &&
            (() =>
              tabContentList.map(item => {
                switch (item.type) {
                  case 'scorecard':
                    return (
                      showScoreCard && (
                        <div
                          className={
                            cricketActiveTabObject &&
                            cricketActiveTabObject.name !== item.name
                              ? s.hideTimeline
                              : ''
                          }
                        >
                          <WithCricketScorecardLoadableV2
                            params={{ ...params, isWapView: true }}
                            autoRefreshRate="20000"
                          />
                        </div>
                      )
                    );
                  case 'optaWidget':
                    return (
                      showOptaWidgets && (
                        <div
                          id={`container-${item.name}`}
                          className={
                            cricketActiveTabObject &&
                            cricketActiveTabObject.name !== item.name
                              ? `${s.hideTimeline} ${s.optacontainer}`
                              : `${s.optacontainer}`
                          }
                        >
                          <Optawidget
                            widgetName={item.name}
                            competition={metaInfo.MigrationId}
                            season={metaInfo.SupplementaryContentId}
                            match={metaInfo.DeviceId}
                            autoload={item.autoLoad}
                          />
                        </div>
                      )
                    );
                  // case 'dataListicle':
                  //   return (
                  //     this.isNonSportsLiveblog &&
                  //     item.dataurl && (
                  //       <div
                  //         className={
                  //           cricketActiveTabObject &&
                  //           cricketActiveTabObject.name !== item.name
                  //             ? s.hideTimeline
                  //             : ''
                  //         }
                  //       >
                  //         <EmbedDataListicleComponent
                  //           dataUrl={`https://api-newscard.indiatimes.com${
                  //             item.dataurl
                  //           }.json`}
                  //           dataSel="data"
                  //           isAppView={isAppView}
                  //           isWapView
                  //         />
                  //       </div>
                  //     )
                  //   );
                  case 'timescricket':
                    return (
                      metaInfo.Matchid &&
                      this.props?.matchStatus?.matchType === 'T20' && (
                        <div
                          id={`container-${item.name}`}
                          className={
                            cricketActiveTabObject &&
                            cricketActiveTabObject.name !== item.name
                              ? s.hideTimeline
                              : ''
                          }
                        >
                          <IframeComponent
                            src={`${item.data.url}${
                              metaInfo.Matchid
                            }&platform=mweb`}
                            title={item.displayName}
                            width="100%"
                            height="360"
                            //marginWidth="0"
                            //marginHeight="0"
                            frameBorder="0"
                            scrolling="no"
                            align="center"
                            loadIframeInView
                          />
                        </div>
                      )
                    );
                  default:
                    return '';
                }
              }))()}
          {/**
           * This is the default tab,
           * commentary in case of sports otherwise default container
           */}
          <div
            className={
              cricketActiveTabObject &&
              !(
                (cricketActiveTabObject.name === 'commentary' ||
                  cricketActiveTabObject.name === 'lb_updates') &&
                ((activeSnippetTabObject.code &&
                  activeSnippetTabObject.code === ALL_SNIPPETS) ||
                  !this.showlbSnippetFilterTabs)
              )
                ? s.hideTimeline
                : ''
            }
          >
            {showOptaWidgets && (
              <OptaWidgetInLine
                ref={instance => {
                  this.OptaWidgetInLineRef = instance;
                }}
                competition={metaInfo.MigrationId}
                season={metaInfo.SupplementaryContentId}
                match={metaInfo.DeviceId}
                gaCategory={this.props.gaCategory}
                isWapView
                matchStatus={this.props.matchStatus}
                displayTabs={false}
              >
                {props => <Optawidget {...props} />}
              </OptaWidgetInLine>
            )}
            {showScoreCard && (
              <LiveblogScoreCard msid={msid} sponsorAd="" isWapView />
            )}
            {this.cricketLiveBlog && (
              <div className={s.social_keyhighlight_wrapper}>
                {!isAppView && (
                  <React.Fragment>
                    <div className={`${s.MoiblestickyShare}`}>
                      <SocialSharingMobile
                        msid={msid}
                        title={title}
                        url={this.state.pageUrl}
                        wu={this.state.pageUrl}
                        via="@timesofindia"
                        whatsAppShow
                        isWapView
                        sticky
                        isTablet={false}
                        wrapperClass="mobile-socialshare-top"
                        gaCategory={this.gaCategory}
                        gaAction={
                          this.state.stickyShare !== ''
                            ? 'sticky_share_header'
                            : 'atf_share'
                        }
                        commentsCount={this.getCommentsData(msid)}
                        // showComment={this.state.stickyShare !== ''}
                        openSidebar={this.openSideBar}
                        forceOpenSidebar
                        utm={this.state.utmshare}
                        disableShortUrl
                      />
                    </div>
                    <SocialInView
                      cbForSticky={this.stickyShareIcons}
                      msid={msid}
                      withminiwidget={!!(showScoreCard || NewExitPollData)}
                    />
                  </React.Fragment>
                )}

                {highlights instanceof Array && highlights.length ? (
                  <Highlights data={highlights} gaCategory={this.gaCategory} />
                ) : null}
              </div>
            )}
            {this.cricketLiveBlog && !description && this.getMrecAD()}
            {this.props.BoardResultData &&
              metaInfo &&
              metaInfo.CARDPAGEID &&
              Object.keys(this.props.BoardResultData).length > 0 && (
                <>
                  <BoardForm
                    key=""
                    data={this.props.BoardResultData}
                    isPrime={this.props.isPrime}
                    location=""
                    isWapView
                    hideBtf
                  />
                </>
              )}
            <div ref={this.timelineRef}>
              <Timeline
                fullPath={params.fullPath}
                sharedItem={this.state.sharedWidgetData}
                isAppView={isAppView}
                updatedContents={updatedContents}
                isWapView
                isLoggedIn={isLoggedIn}
                toggleLoginBox={this.props.toggleLoginBox}
                msid={msid}
                showSocialMsid={this.state.showSocialMsid}
                utm="&source=share&medium=####&campaign=liveblog_new_mweb"
                gaCategory={this.gaCategory}
                usePopupPortal
                url={pageUrl}
                title={title}
                showToiPlusNudges={this.props.showToiPlusNudges}
                affKeyword={affKeyword}
                navsubsecs={navsubsecs}
                matchStatus={this.props.matchStatus}
                snippetSponsorMapping={this.state.snippetSponsorMapping}
                isPrime={this.props.isPrime}
                withScrollAnchor
                articleId={articleId}
                cardsInsertsLite={cardsInsertsLite}
                location={location}
                topicTree={metaInfo.LiveBlogName}
                // setReadNextApiFailEventTrigger={
                //   this.setReadNextApiFailEventTrigger
                // }
                // readNextApiFailEventCaptured={
                //   this.state.readNextApiFailEventCaptured
                // }
              />
            </div>
            <Pagination
              getMoreRecords={this.props.loadTimelineDataPagination}
              params={params}
              count={count}
              gaCategory={this.gaCategory}
            />
            {mobilesynopsis && (
              <div
                className="art_synopsis lbg_synopsis btmsyn"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: `${mobilesynopsis}`,
                }}
              />
            )}
          </div>
          {/**
           * This is to create a container for All the liveblog snippets
           */}
          <div
            className={
              cricketActiveTabObject &&
              !(
                (cricketActiveTabObject.name === 'commentary' ||
                  cricketActiveTabObject.name === 'lb_updates') &&
                (activeSnippetTabObject.code &&
                  activeSnippetTabObject.code !== ALL_SNIPPETS)
              )
                ? s.hideTimeline
                : ''
            }
          >
            <div>
              {this.showlbSnippetFilterTabs &&
                (this.state.allSnippetContents.length > 0 ? (
                  <Timeline
                    fullPath={params.fullPath}
                    isAppView={isAppView}
                    updatedContents={this.state.allSnippetContents}
                    isWapView
                    isLoggedIn={isLoggedIn}
                    toggleLoginBox={this.props.toggleLoginBox}
                    msid={msid}
                    showSocialMsid={this.state.showSocialMsid}
                    utm="&source=share&medium=####&campaign=liveblog_new_mweb"
                    gaCategory={this.gaCategory}
                    usePopupPortal
                    url={pageUrl}
                    title={title}
                    snippetSponsorMapping={this.state.snippetSponsorMapping}
                    isPrime={this.props.isPrime}
                    cardsInsertsLite={cardsInsertsLite}
                    location={location}
                    topicTree={metaInfo.LiveBlogName}
                  />
                ) : (
                  <div className={s.notimelinedata}>{NO_RECORDS_TEXT}</div>
                ))}
            </div>
          </div>
          {isEtimes &&
            topSearches &&
            topSearches.items &&
            topSearches.items.length > 0 && (
              <div>
                <LinksList
                  sectionData={{
                    ...topSearches,
                    data: [...topSearches.items],
                  }}
                  cssSelector="astrendinglist"
                  gaCategory={
                    this.props.pageType === 'ARTICLESHOW' &&
                    this.props.categoryForGA
                      ? `${this.props.categoryForGA}`
                      : 'ATF_seo_links'
                  }
                  gaAction={
                    this.props.pageType === 'ARTICLESHOW'
                      ? 'click-seo_top-header-links'
                      : 'link_###index###'
                  }
                  gaLabel={this.props.pageType === 'ARTICLESHOW' ? 'wu' : ''}
                  isEtimes
                  ga4Type="top_band-seo"
                />
              </div>
            )}
          {/* Trending Top Searches Starts */}
          {!isEtimes &&
            topSearches &&
            Array.isArray(topSearches.items) &&
            topSearches.items.length > 0 && (
              <div
                className={
                  this.isNonSportsLiveblog ? s.trending_wrapper_main : ''
                }
              >
                <TrendingMarquee
                  topSearches={topSearches.items}
                  title={topSearches.name}
                />
              </div>
            )}
          {/* Trending Top Searches Ends */}
          {!isAppView && (
            <div data-scrollga="scroll#comments_view">
              <WithCommentLoader
                msid={msid}
                isWapView
                seoData={seo}
                showBottomCommentsV2
                isTimelineVisible
                showCommentsOnMobile
                postCommentText="add comment"
                isSidebarPortable
                hideBottomComments
                loadCommentsSidebarOutside={this.loadCommentsSidebar}
              />
            </div>
          )}
          {/* Playing XI widget */}
          {showScoreCard &&
            typeof matchDetailsData !== 'undefined' &&
            typeof matchDetailsData.data !== 'undefined' && (
              <MatchCornerWidget data={matchDetailsData.data} usePopupPortal />
            )}
          {!isAppView &&
            topStoriesData &&
            topStoriesData.wu && (
              <TopStoriesWrapper
                url={topStoriesData.wu}
                msid={topStoriesData.msid}
                morlinkOpenInNewTab="yes"
                gaPrefix="RHS"
                gaCategory={this.gaCategory}
                // gaAction="top_stories_rhs_wap"
                setScrollGA={this.setScrollGAElements}
              />
            )}
          {/* CTN BTF ad */}
          {!isAppView && (
            <div data-scrollga={`ad_view_${updatedContents.length}`}>
              <AdCaller
                data={{
                  name: 'towerad',
                }}
                isCTN
                className="ctn-paisa"
                deviceType="mobile"
              />
            </div>
          )}
          {!isAppView &&
            ASCardsData &&
            ASCardsData.wu && (
              <div data-scrollga="scroll#moreStories_view">
                <ArticleshowCards
                  url={ASCardsData.wu}
                  msid={ASCardsData.msid}
                  isWapView
                />
              </div>
            )}
          {/* <PrimePaymentFlowCaller /> */}
          {!isAppView && (
            <div data-footer={msid}>
              {quickLinks instanceof Array && quickLinks.length ? (
                <MoreFromToi
                  moreFromToidata={quickLinks}
                  title="Quick Links"
                  quicklink
                  isWapView
                />
              ) : (
                ''
              )}
            </div>
          )}
          {/* <TimesClubWidgetLoaderWithPopup isWapView /> */}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  sidebarData: state.sidebar ? state.sidebar.data : {},
  liveblog: state.liveblog_v2,
  timelineData: state.liveblog_v2.timelineData,
  userData: state.login.userData,
  comments: state.comments,
  extraData: state.liveblog_v2.extraData,
  exitPollData: state.liveblog_v2.exitPollData,
  affiliatesNudgeVisible: _get(state, 'affiliates.saleNudgeVisible'),
  showToiPlusNudges: _get(state, 'toiplusconfig.showToiPlusNudges', false),
  matchStatus: state.cricketScorecard.matchStatus,
  dataListicleTabs: state.liveblog_v2.listicletabs,
  BoardResultData: state.liveblog_v2.boardresultdata,
  allSnippetContents: state.liveblog_v2.allLiveblogContent,
  lbSnippetFilterTabsMeta: state.liveblog_v2.lbSnippetFilterTabsMeta,
  lbSnippetFilterTabs: state.liveblog_v2.lbSnippetFilterTabs,
  isPrime: state.isPrime,
  cardsInsertsLite: state.liveblog_v2.cardsInsertsLite,
  commonData: state.commonData && state.commonData.data,
  electionTabs: state.common?.siteConfig?.electionTabs,
});

const mapDispatchToProps = dispatch => ({
  toggleLoginBox: params => {
    dispatch(toggleLoginBox(params));
  },
  loadTimelineDataPagination: params => {
    dispatch(loadTimelineDataPagination(params));
  },
  loadLiveblogDataCount: params => {
    dispatch(loadLiveblogDataCount(params));
  },
  loadTimelineData: params => {
    dispatch(loadTimelineData(params));
  },
  openSidebar: (params, id) => {
    dispatch(openSidebar(params, id));
  },
  loadCompleteTimelineData: params => {
    dispatch(loadCompleteTimelineData(params));
  },
});

Liveblog.propTypes = {
  timelineData: PropTypes.shape({
    title1: PropTypes.string.isRequired,
    information1: PropTypes.string,
    mobilesynopsis: PropTypes.string,
    lastupd: PropTypes.string,
    msid: PropTypes.string.isRequired,
    highlights: PropTypes.shape([]),
  }).isRequired,
  liveblog: PropTypes.shape({
    quickLinks: PropTypes.shape([]),
    widgets: PropTypes.shape([]),
    contents: PropTypes.shape([]),
    count: PropTypes.number,
    params: PropTypes.shape({}),
    seo: PropTypes.shape({}),
    metaInfo: PropTypes.shape({}),
    newCount: PropTypes.number,
    ads: PropTypes.shape({}),
    inlineAds: PropTypes.shape([]),
    nextLinks: PropTypes.shape([]),
    images: PropTypes.shape([]),
    upd: PropTypes.string,
    slikeId: PropTypes.string,
    affKeyword: PropTypes.string,
    navsubsecs: PropTypes.shape([]),
    des: PropTypes.string,
  }).isRequired,
  toggleLoginBox: PropTypes.func,
  userData: PropTypes.shape({
    isLoggedIn: PropTypes.bool,
  }),
  loadTimelineDataPagination: PropTypes.func,
  loadLiveblogDataCount: PropTypes.func,
  loadTimelineData: PropTypes.func,
  loadCompleteTimelineData: PropTypes.func,
  sharedMsid: PropTypes.string,
  openSidebar: PropTypes.func.isRequired,
  exitPollData: PropTypes.shape({
    feedURL: PropTypes.string,
  }),
  extraData: PropTypes.shape({ feedURL: PropTypes.string }),
  // isElection: PropTypes.bool,
  colorTheme: PropTypes.string,
  isAppView: PropTypes.bool,
  electionFlag: PropTypes.bool,
  affiliatesNudgeVisible: PropTypes.bool.isRequired,
  showToiPlusNudges: PropTypes.bool,
  dataListicleTabs: PropTypes.shape([]),
  BoardResultData: PropTypes.shape({}),
  isEtimes: PropTypes.bool,
  lbSnippetFilterTabsMeta: PropTypes.shape({}),
  lbSnippetFilterTabs: PropTypes.shape([]),
  allSnippetContents: PropTypes.shape([]),
};

Liveblog.defaultProps = {
  toggleLoginBox: () => {},
  userData: { isLoggedIn: false },
  loadTimelineDataPagination: () => {},
  loadLiveblogDataCount: () => {},
  loadTimelineData: () => {},
  loadCompleteTimelineData: () => {},
  sharedMsid: '',
  exitPollData: undefined,
  extraData: {},
  // isElection: false,
  colorTheme: '',
  isAppView: false,
  electionFlag: false,
  showToiPlusNudges: false,
  dataListicleTabs: [],
  BoardResultData: {},
  isEtimes: false,
  lbSnippetFilterTabsMeta: {},
  lbSnippetFilterTabs: [],
  allSnippetContents: [],
};

// export default Liveblog;
export default connect(mapStateToProps, mapDispatchToProps)(Liveblog);
